export default __webpack_public_path__ + "static/media/pointer.c0c8de1a.png";